export default __webpack_public_path__ + "static/media/Corporate_2.9e65f09a.png";